// extracted by mini-css-extract-plugin
export default {"modalOverlay":"yj-z","modalContent":"zj-z","header":"Aj-z","close":"Bj-z"};